var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonDrop',{ref:"companyDrop",attrs:{"url":"/trade/company/list","autoDefault":false,"filterable":true,"remote":true,"size":_vm.size,"clearable":_vm.clearable,"disabled":_vm.disabled},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }